var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ritm-tree',{attrs:{"tree-data":_vm.treeData,"loading":_vm.loading,"show-tools":_vm.showTools,"tool-click":_vm.toolClick,"node-click":_vm.nodeClick,"active-nodes":_vm.activeNodes,"icon-by-item":_vm.iconByItem,"tool-kit":_vm.toolKit,"no-tools":_vm.noTools,"no-animations":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }